/* eslint-disable max-len */

export default {
  lang: 'English',
  homeScreen: {
    title: 'THE LINDBLAD DIFFERENCE', // Product specific
    stayConnected: 'Stay Connected',
    comingSoon: 'Coming Soon',
    messages: 'Messages',
  },
  loginScreen: {
    title: 'Travel Professional Training and Sales Enablement Program', // Product specific (TravPRO text or ChannelPRO text)
    welcome: {
      headerTop: 'Welcome to',
      headerBottom: 'Expedition 360', // Product specific
    },
    forgot: 'Reset Password',
    version2: {
      homeTitle:
        "Let's see if we can find an existing profile for you in our system.",
      homeTitleSub:
        'Enter the email address you typically use to login to training programs.',
      noAccount:
        'No account found ({email}), please try with another email or create an account now.',
      continueButton: 'Continue',
      success:
        'Successfully updated your account! You will be redirected shortly to the home page.',
      successNewAccount:
        'Successfully registered, please confirm your account via email first! You will be redirected shortly to the login page.',
      loginButton: 'Login',
      matchFound:
        'We have found a match, please fill in your password to continue.',
      magicLink: 'Login via a link in your email:',
      magicLinkButton: 'Request Magic Link',
      magicLinkTitle:
        'Get a direct link sent to your email that will sign you in instantly.',
      otherEmailButton: 'Submit',
      title:
        'Please take a moment to complete all the information below as it will populate your personal profile and contact information.',
      titleIndustry:
        'Please take a moment to complete all the information below as it will populate your personal profile and contact information.',
      register: 'Create an account',
      agent: 'Travel Advisor',
      visitor: 'Industry Visitor',
      step1: 'Step 1: Type of User',
      step2: 'Step 2: Create An Account',
      marketingOptIn:
        'Are you sure you want to opt out of communications from this program’s travel trade team? You won’t be notified of timely product updates, specialist benefits & rewards programs, or sales missions & supplier events.',
      optIn: 'Opt-In',
      optOut: 'Opt-Out',
      step3: 'Step 3: Create Your Profile',
      step2Sub1: 'Tell Us About Yourself',
      step2Sub2: 'Tell Us About Your Business',
      privacyHead: 'COMMUNICATIONS PREFERENCES',
      privacySub:
        'Check the boxes below to ensure you receive important communications from the supplier’s travel trade team (product updates and announcements, rewards, incentives, FAMs, etc.) and travel trade networking and sales support initiatives from TravPRO Mobile.',
      privacy:
        'We protect your privacy and never sell, misuse or betray your trust.',
      store: 'Easily download this program at your app store:',
      powered: 'POWERED BY',
      toastMessage: {
        forgotSuccess:
          'We have e-mailed your password reset link! You will be redirected to the login page in 10 seconds.',
        emailNotExisting: "The email address you entered doesn't exist.",
        magicLinkMessage: 'Please wait, we are signing you in right now.',
        magicLinkError:
          "We couldn't find your account in our database, please log in manually. You will be redirected in 10 seconds.",
        magicLinkError1:
          "We couldn't find a valid token, please login or request a new magic link. If this problem persists, please contact us at: info@travpromobile.com.",
        magicLinkError2:
          "We couldn't find your account in our database, please log in manually. You will be redirected in 10 seconds.",
        magicLinkSuccess:
          "Check your email at {email}. It has a magic link that'll sign you in.",
        magicLinkErrorWait:
          'Please wait 5 minutes in between magic link requests.',
        emailNotFoundError:
          'The email address you entered can’t be found in our records. Please check for misspellings or create an account.',
      },
      errors: {
        zipCodeNotFound: 'ZipCode not found, try again',
        zipCodeOnlyNumbers: 'ZipCode can only contain numbers',
        password: 'Please enter a password',
        passwordNotMatching: 'The passwords you entered do not match',
        passwordTooShort: 'Password needs to be at least 8 characters',
        emailExists:
          'This email address already exists or is invalid. Please try with another email address or login to your account.',
        fillInAllFields: 'Please fill in all the required fields',
        fillInEmail: 'Please fill in your email.',
        emailNotExisting: "The email address you entered doesn't exist.",
      },
      fields: {
        forgotSubCopy: 'Forgot your password & want to change it? ',
        forgotSubCopy2:
          'Want to bypass password entirely? We will send you an email with a magic link that will automatically log you into the program. ',
        city: 'City',
        companyName: 'Company Name',
        role: 'Your Role',
        description: "Which best describes your company's business?",
        country: 'Country',
        password: 'Password',
        passwordRegister: 'Choose Password (8 character minimum)',
        passwordConfirm: 'Confirm Password',
        firstName: 'First Name (Given)',
        lastName: 'Last Name (Family)',
        agency: 'Your Agency Name',
        title: 'Your Role (Select One)',
        company: 'Company Name',
        select: 'Select an option below',
        state: 'State',
        province: 'Province/Region/State',
        zipCode: 'Zip Code',
        postalCode: 'Postal Code',
        affiliate: 'Which group is your MAIN agency affiliation?',
        hostAgency: 'Your Host Agency?',
        executive: 'Executive',
        management: 'Management',
        marketing: 'Marketing',
        sales: 'Sales',
        coordinator: 'Coordinator',
        other: 'Other',
        opt: "Stay connected to this program's travel trade team and receive updates.",
        optMarketing:
          'Stay connected to TravPRO regarding similar programs and events.',
        retail: 'Retail Store Front',
        home: 'Home-Based Agent',
        independent: 'Independent Contractor',
        host: 'Host Agency',
        call: 'Call Center or Web-Based Agency',
        other: 'Other ',
        describes: 'What best describes you and your agency’s business? ',
      },
    },
    sellingPoints: {
      // All selling points can be product specific
      0: '$100 Bonus Commission on the First New Booking Made within 120 days of Completing the Course',
      1: 'Special Booking Opportunities Throughout the Year',
      2: 'Exclusive Educational (FAM) Opportunities for Graduates',
      3: 'Listing in the ‘Find a Travel Advisor’ Portion of the Lindblad Expeditions Website',
      4: 'Sales and Marketing Support for Your Consumer Events',
      5: 'Dedicated Social Media Toolkits',
      6: 'Access to Lindblad Expedition’s Dedicated Travel Advisor Facebook Community',
    },
    emailPrompt:
      'Please enter your email address and password to confirm that you are a travel professional.', // Product specific (TravPRO or ChannelPRO text)
    tAndC: {
      agree: 'By continuing you agree with our ',
      privacyPolicy: 'privacy policy',
      and: ' and ',
      termsConditions: 'terms and conditions',
    },
    fields: {
      agency: 'Agency',
      email: 'Email',
      password: 'Password',
      passwordConfirm: 'Confirm your password',
      firstName: 'First name',
      lastName: 'Last name',
      agencyName: 'Agency Name',
      stateProvince: 'State / Province',
      required: 'Required',
      invalidEmail: 'Invalid email address',
      forgot:
        'Forgot your password? Click the button below and we’ll send you an email to reset your password',
      opt: "Stay In Touch! Yes, I'd like to opt in to communications from Lindblad Expeditions that will keep me posted on news, events, incentives, FAM’s and more!",
    },
    noAgent: {
      noAgentButton: "I'm not an advisor",
      title:
        'Thank you for your interest in Lindblad Expeditions Sales Companion.', // Product specific
      messageWeb:
        'The content on this site is exclusively for travel professionals. \n To learn more about Lindblad Expeditions, please visit: ', // Product specific
      messageMobile:
        "Some content on this app is exclusively for travel professionals, but feel free to browse a preview of what this app has to offer by pressing 'Continue'.", // Product specific
      continue: 'Continue',
      visitWebsite: 'Visit website',
    },
    newUser: 'New User',
    register: 'Register',
    registered: 'This email is already registered',
  },
  welcomeScreen: {
    title: 'Welcome to \nLindblad Expeditions', // Product specific
    helloUser: 'Hello {{name}}',
    hello: 'Hello,',
    fromAgency: 'from {{agency}}',
    notUser: 'Not {{name}}?',
    introOnline:
      "Train immediately online or preload the content so it's always available for offline use!",
    introOffline:
      'You already have the latest version preloaded. Start training or selling anytime, anywhere!',
    startTraining: 'Start learning',
    continueTraining: 'Continue learning',
    graduated: 'Congratulations!',
    downloader: {
      preload: 'Preload',
      stop: 'stop',
      init: 'Initializing...',
      lastUpdate: 'Last update: ',
    },
  },
  trainingScreens: {
    start: 'Start',
    continue: 'Continue',
    review: 'Review',
    restart: 'Restart',
    durationInMinutes: '{number} minutes',
    percentageComplete: '{number}% Complete',
    unlock: 'Unlock this chapter by completing training chapter {number}.',
    unlockSubtitle: 'Unlock more chapters by completing training chapters.',
    allUnlocked: 'You have unlocked all chapters!',
    certificate: 'Certificate',
    courseComplete: 'Continue',
    endReached: "You've reached the end",
    retainEnd:
      'Use the top bar to navigate around in this chapter or press the back button to return to the overview.',
    watchListenRead: 'Watch, Listen & Read more',
    trouble:
      "It looks like you're having trouble, please re-read the content on the previous page(s) and try again.",
    confirm: 'Confirm your answer',
    choose: 'Please choose an answer',
    skip: 'Return >',
    viewAllTitle: 'Training Tip',
    viewAll:
      'In order to proceed to the next page, please click on the icons to view the supplementary content. Videos, maps and other helpful information have been provided to enhance your training and ensure you achieve PRO status.',
    fillBlanks: 'Fill in the blank(s):',
    next: 'Next question',
    retry: 'Try Again',
    fastTrackText: {
      success:
        "Congratulations, you've passed the Fast Track course and unlocked the rest of the training!",
      failed:
        "Unfortunately you didn't pass the Fast Track course, you can resume your training to earn your diploma!",
    },
    fastTrack: 'Become a Swiss Travel Superstar!',
    fastTrackExplanation:
      'Simply take the quiz on the following pages for your chance to win a FAM to Switzerland!<br><br><span style="font-weight: bold">You will find all answers to the quiz questions in the following ways:</span><br><br>1.	The content that you learned in the Rail Europe and Switzerland modules<br><br>2.	And on the following websites:<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><span style="font-weight: bold">Be sure to review these resources in detail before taking the quiz! Only those with the highest of scores will have the chance to be invited to the FAM.</span>',
    fastTrackButton: 'Click Here to Take the Swiss Superstar Quiz',
    grading: 'Your final grade is: {grade}%',
  },
  nav: {
    home: 'Home',
    train: 'Train',
    learn: 'Train',
    retain: 'Retain',
    directory: 'Directory',
    showRoom: 'Hotel Spotlights',
    showcases: 'Showcases',
    promote: 'Promote',
    sell: 'Sell',
    info: 'Info',
    rewards: 'Rewards',
    media: 'Media',
    favorites: 'Favorites',
    contact: 'Contact',
    reportCard: 'View Diploma',
    accountSettings: 'Account Settings',
    messages: 'Messages',
    search: 'Search',
  },
  contentHeaders: {
    train: 'Train',
    retain: 'Retain',
    subapps: 'Lindblad Expeditions Partner Modules',
    maintrainings: 'The Foundation',
    subtrainings: 'THE EXPEDITIONS',
  },
  pageDescriptions: {
    train: 'Educate, engage and become the expert.',
    showroom: '',
    retain:
      'Your go-to resource for retaining your expert knowledge and enabling your sales efforts. Use this area to expertly answer a product question or even as an impromptu sales presentation — anytime, anywhere and from any device.',
    promote: 'Start the conversation with your clients and prospects.',
    sell: 'Answer client questions and close the sale.',
    favorites: 'Check out your personally favorited content',
    search: 'Look through all content',
    subapps: '',
    maintrainings:
      'Complete these modules to learn the basics for selling Lindblad Expeditions.',
    subtrainings:
      'Take a deeper dive into the worldwide adventures awaiting your clients.',
  },
  general: {
    or: 'or',
    noThankYou: 'No, thank you',
    yesPlease: 'Yes, please',
    check: 'Please enable',
    next: 'Next',
    yes: 'Yes',
    no: 'No',
    previous: 'Previous',
    submit: 'Submit',
    back: 'Back',
    close: 'Close',
    page: 'Page',
    search: 'Search',
    logIn: 'Log in',
    logOut: 'Log Out',
    viewItem: 'View {type}',
    imageNotFound: 'Image not found',
    noResultsFor: 'No results have been found for: {{query}}',
    noFavorites: "You don't have any favorites yet.",
    noMessages: "You haven't received any messages yet!",
    resultsFor: 'Results for: {{query}}',
    showAll: 'Show all',
    connectionError: 'Connection error',
    alreadyExists: 'Already exists',
    pageNotFound: '404 Page Not Found!',
    oops: 'Uh oh...',
    overview: 'Return to overview',
    complete: 'Continue',
    courseComplete: 'Course Complete!',
    chapterComplete: 'Chapter Completed!',
    message: '{count} Message',
    messagePlural: '{count} Messages',
  },
  itemTypes: {
    image: 'Image',
    brochure: 'Collection',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Collection',
  },
  questions: {
    dials: 'Rotate the dials to match the answer',
    fitb: 'Fill in the blank(s)',
    flip: 'Change the number to match the answer',
    multipleChoice: 'Pick the right answer(s)',
    slider: 'Pick the right answer using the slider',
    map: 'Answer the question by tapping the right location on the map',
    dropdown: 'Choose...',
    true: 'True',
    false: 'False',
  },
  reportCard: {
    download: 'Download',
    email: 'Email',
    print: 'Print',
  },
  cookies: {
    consent: 'AGREE',
    optout: 'Opt-out',
    settings: 'Privacy Settings',
    message:
      "You haven't told us anything about your data privacy preferences! That's ok, but we'd like to offer you the best experience using the Sales Companion.",
    disabled: 'It looks like you have disabled the use of cookies.',
    use: 'The {{appName}} requires the use of cookies to deliver you the best experience.',
    details: 'What are the cookies used for?',
    enable: 'See how to enable your cookies {{here}}.',
    here: 'here',
  },
  notLoggedIn: {
    super: "You're not logged in",
    title: 'You need to be logged in to view this content',
    guest: 'Guest',
  },
  demo: {
    message:
      'This website is a demo of the final product. It is currently in-development and not a complete product.',
    consent: 'Understood!',
  },
  share: {
    header: 'Share this resource on your favorite social media!',
    download: 'Download',
  },
  sharing: {
    copyURL: 'Copy Link',
    copied: 'Copied',
  },
  breadCrumbs: {
    page: 'Page',
  },
  onMobile: {
    header:
      "It looks like you're trying to access the {appName} app from a mobile device",
    body: 'To download this program simply visit your app store and search for {appName} or click one of the buttons below',
    benefits: {
      header: 'This will provide you with:',
      1: 'Certificate of completion',
      2: 'Free, high-quality marketing materials',
      3: 'Qualify to participate in destination FAMS',
      4: 'High Impact Sales Information & Resources',
      5: 'Access to mobile Sales Companion App',
      6: 'Sales tips',
    },
  },
  custom: {
    splitUsers: 'I Am A ...',
    brandAmbassador: 'Brand Ambassador',
    travelPro: 'Travel Professional',
  },
  search: {
    pages: 'Pages',
    resources: 'Resources',
  },
};
